export default __webpack_public_path__ + "static/media/footer-program-img-2.0a686155.png";